// extracted by mini-css-extract-plugin
module.exports = {"category":"styles-m__category__a9m8-","category-icon":"styles-m__category-icon__3Mdh0","category-name":"styles-m__category-name__3H4lB"};